import React from "react";
import styles from "../styles/Sidebar.module.css";

export default function Sidebar() {
  return (
    <aside id="sidebar" className={styles.sidebar}>
      <div className={styles.photoWrap}>
        <img
          className={styles.profilePhoto}
          src="https://i.pravatar.cc/220?img=11"
          alt="Nathan Martins profile photo"
        />
        <div className={styles.sidebarName}>
          Nathan Marcos
          <br />
          Linhares Silva Martins
        </div>
        <div className={styles.sidebarRole}>Advertiser · Designer</div>
      </div>

      <div className={styles.sbSection}>
        <div className={styles.sbLabel}>Contact</div>
        <a
          className={styles.contactItem}
          href="https://nathan.marketing"
          target="_blank"
          rel="noreferrer"
        >
          <div className={styles.ciIcon}>🌐</div>nathan.marketing
        </a>
        <a className={styles.contactItem} href="mailto:nathanmls@hotmail.com">
          <div class={styles.ciIcon}>✉️</div>nathanmls@hotmail.com
        </a>
        <a className={styles.contactItem} href="tel:+31627293829">
          <div class={styles.ciIcon}>📞</div>+31 627 29 3829
        </a>
        <div className={styles.contactItem}>
          <div className={styles.ciIcon}>📍</div>Amsterdam, NL
        </div>
        <div className={styles.contactItem}>
          <div className={styles.ciIcon}>🪪</div>Work permit · NL
        </div>
      </div>

      <div className={styles.sbSection}>
        <div className={styles.sbLabel}>Languages</div>
        <div className={styles.langItem}>
          <span>English</span>
          <span className={styles.langLevel}>Professional</span>
        </div>
        <div className={styles.langItem}>
          <span>Portuguese</span>
          <span className={styles.langLevel}>Native</span>
        </div>
      </div>

      <div className={styles.sbSection}>
        <div className={styles.sbLabel}>Hobbies</div>
        <div className={styles.hobbyGrid}>
          {[
            "🎵 Music",
            "🎮 Games",
            "🎬 Movies/TV",
            "🥾 Hiking",
            "💻 Technology",
            "🏊 Swimming",
          ].map((h) => (
            <div key={h} className={styles.hobbyTag}>
              {h}
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
